import React from 'react';
import { CardHeader, Divider, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState, Fragment } from 'react';
import { gatewayMasterActions } from '../../store/reducers/gateway-master';
import { useDispatch } from 'react-redux';
import Styles from '../../theme/commonCss/Styles';
import FilterData from '../../common/filterData';
import { gatewayDetailsSchema, gatewayDetailsUISchema, gatewayMetaDataSchema } from './form';
import Ajv from 'ajv';
import AjvErrors from 'ajv-errors';
import FormModal from '../../common/formModal';
import reduce from 'lodash/reduce';
import MetaTagsTable from '../../common/metaTagsTable';
import { get } from 'lodash';
import { useOutletContext } from 'react-router-dom';

const GatewayStyles = {
  formWrapper: {
    ...Styles.gridContainer,
    '&.MuiGrid-root': {
      paddingBottom: '20px !important',
    },
    marginLeft: 0,
  },
  select: {
    '&.MuiGrid-item': {
      padding: '0px',
    },
  },
  input: {
    '&.MuiTextField-root': {
      margin: '0px',
    },
  },
};

const AddGateway = ({
  isOpen,
  gatewayData,
  setGatewayData,
  gatewayTagsData,
  setGatewayTagsData,
  isEdit,
  closeModal = () => {},
  ontologyData,
  pageData
}: any) => {
  const themeData: any = useTheme();
  const dispatch = useDispatch();
  const ajv = new Ajv({ allErrors: true });
  AjvErrors(ajv);

  const [ajvErrors, setAjvErrors] = useState<any>({});

  const responsiveSize = useMediaQuery('(max-width:900px)');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setGatewayData({ ...gatewayData, [name]: value });
  };

  const handleSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();

    let ajvSchema: any = { ...gatewayDetailsSchema };

    if (gatewayTagsData.length) {
      ajvSchema = {
        ...gatewayDetailsSchema,
        properties: {
          ...gatewayDetailsSchema.properties,
          gateway_tags: {
            type: 'array',
            items: gatewayTagsData.map((item: any) => gatewayMetaDataSchema),
          },
        },
        required: [...gatewayDetailsSchema.required, 'gateway_tags'],
      };
    }

    const validate = ajv.compile(ajvSchema);

    const trimmedGatewayData = reduce(
      gatewayData,
      (acc: any, value: any, key: any) => {
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return {
          ...acc,
        };
      },
      {}
    );
    setGatewayData(trimmedGatewayData);

    const trimmedGatewayTag = gatewayTagsData.map((item: any) => {
      return {
        ...item,
        key: typeof item.key === 'string' ? item.key.trim() : item.key,
        value: typeof item.value === 'string' ? item.value.trim() : item.value,
      };
    });

    setGatewayTagsData(trimmedGatewayTag);

    const reqParams = {
      ...trimmedGatewayData,
      gateway_tags: trimmedGatewayTag,
    };
    if (validate({ ...reqParams })) {
      if (isEdit) {
      } else {
        dispatch(gatewayMasterActions.addGatewayRequest(reqParams));
      }
      setAjvErrors({});
      closeModal();
    } else {
      if (validate.errors) {
        setAjvErrors(validate.errors[0]);
      }
    }
  };

  const getOntoSelectedValue = (data: any) => {
    setGatewayData({ ...gatewayData, onto_manage_id: data.onto_manage_id });
  };

  return (
    <FormModal
      isOpen={isOpen}
      title={`${isEdit ? 'EDIT ' : 'ADD NEW '} ${get(pageData,'entity_name','GATEWAY').toUpperCase()}`}
      handleSubmit={handleSubmit}
      handleClose={closeModal}
    >
      <CardHeader title={`${get(pageData,'entity_name','Gateway')} Details`} titleTypographyProps={Styles.title} />
      <Divider />
      <Grid container spacing={1} sx={GatewayStyles.formWrapper}>
        {gatewayDetailsUISchema.map(({ label, name, type, required }) => {
          if (type === 'input') {
            return (
              <Fragment key={name}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  sx={{
                    ...Styles.gridItem,
                    '&.MuiGrid-item': {
                      paddingTop: responsiveSize ? '12px' : '22px',
                      pl: '0px ',
                      justifyContent: responsiveSize ? 'flex-start' : 'flex-end',
                    },
                  }}
                >
                  <Typography sx={{ ...Styles.inputLabel, color: themeData.palette.text.primary }} className={required ? 'required-field' : ''}>
                  {label}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  sx={{
                    '&.MuiGrid-item': {
                      padding: responsiveSize ? '4px 0px 12px' : '12px 0px !important',
                    },
                  }}
                >
                  <TextField
                    sx={GatewayStyles.input}
                    margin='normal'
                    fullWidth
                    id={name}
                    onChange={handleChange}
                    name={name}
                    autoComplete={name}
                    autoFocus
                    variant='outlined'
                    value={gatewayData[name]}
                    size='small'
                    helperText={name==='cidr_to_scan' ? <div style={{display:'flex', flexDirection:'column'}}><small style={{color: themeData.palette.text.primary, fontSize:'0.75rem'}}>IP range format e.g. 192.168.10.0/24 or 192.168.1.0-255 or 192.168.1.20-30  </small>{ajvErrors.instancePath && ajvErrors.instancePath.includes(name) && <div style={{lineHeight:'1'}}>{ajvErrors.message.toLowerCase()}</div>} </div>  : ajvErrors.instancePath && ajvErrors.instancePath.includes(name) && ajvErrors.message.toLowerCase()}
                    error={ajvErrors.instancePath && ajvErrors.instancePath.includes(name)}
                  />
                </Grid>
              </Fragment>
            );
          } else if (type === 'select') {
            return (
              <Fragment key={name}>
                <FilterData
                  ontologyData={ontologyData}
                  showLayout={false}
                  onOntoFilterChange={getOntoSelectedValue}
                  isError={ajvErrors.instancePath && ajvErrors.instancePath.includes(name)}
                />
              </Fragment>
            );
          } else {
            return <></>;
          }
        })}
      </Grid>

      <CardHeader
        title='Metadata (Supporting information for effective search)'
        titleTypographyProps={Styles.title}
      />
      <Divider />
      <MetaTagsTable
        data={gatewayTagsData}
        setData={setGatewayTagsData}
        error={ajvErrors.instancePath && ajvErrors.instancePath.includes(`gateway_tags/`)}
      />
    </FormModal>
  );
};

export default AddGateway;
